import { Record } from "immutable";
import moment from "moment";

const defaults = {
    created_at_ms: undefined,
    poi_id: undefined,
    name: "",
    created_by_identity: "",
    description: "",
    document_id: "",
    meta: {},
    namespace: "",
    object_refs: [],
};

export class CollectionPOI extends Record(defaults) {
    declare created_at_ms: moment.Moment;
    declare poi_id: string;
    declare name: string;
    declare created_by_identity: string;
    declare description: string;
    declare document_id: string;
    declare meta: any;
    declare namespace: string;
    declare object_refs: any;

    constructor(args) {
        super({
            ...args,
            created_at_ms: moment.utc(parseInt(args.created_at_ms, 10)),
        });
    }
}
